const infiniteScroll = () => {
  $(window).on('scroll', () => {
    const infiniteScrollElement = $('.mr-infinite-scroll');
    const loaderImg = infiniteScrollElement.siblings('.img-loader');
    let scrollable = false;
    const isBlogPage = $('.main-blog').length;

    if (isBlogPage) {
      scrollable =
        infiniteScrollElement.length &&
        infiniteScrollElement.is(':not(:disabled)');
    } else {
      scrollable =
        !loaderImg.hasClass('is-loading') &&
        infiniteScrollElement.length &&
        infiniteScrollElement.is(':not(:disabled)');
    }

    if (scrollable) {
      const infiniteScrollElementHeight =
        infiniteScrollElement.offset().top + 100;
      const windowHeight = $(window).scrollTop() + $(window).height();

      if (windowHeight > infiniteScrollElementHeight) {
        infiniteScrollElement.click();
        if (!isBlogPage) {
          loaderImg.addClass('is-loading');
          setTimeout(() => {
            loaderImg.removeClass('is-loading');
          }, 2000);
        }
      }
    }
  });
};

export default infiniteScroll;
